import type { User as AuthUser } from '@models/auth/user';

/**
 * Object helper to user authentication
 */
export default {
  /**
   * Look into dataset of header to see if user is logged in
   */
  isLoggedIn(): boolean {
    return !!window.USER;
  },

  /**
   * If user is auth, returns json with id and email
   */
  getUser(): AuthUser | undefined {
    return window.USER;
  },

  isImpersonated(): boolean {
    return !!window.IMPERSONATED;
  },

  /**
   * returns number of notifications or null
   */
  countNotifications(): number | null {
    if (!window.USER_NOTIFICATIONS) {
      return null;
    }

    return window.USER_NOTIFICATIONS.unread_total;
  },
};
